import { Form, FormField, RequiredValidator, IFormField } from '@thinknimble/tn-forms'

export type ReceiptFormInputs = {
  name: IFormField<string>
  asset: IFormField<File[]>
  extension: IFormField<string>
}

export class ReceiptForm extends Form<ReceiptFormInputs> {
  //ts-ignore
  static _name = new FormField({ validators: [] })
  static asset = new FormField({ validators: [new RequiredValidator()], value: [] })
  static extension = new FormField({ validators: [] })
  get formData() {
    const form = this as unknown as ReceiptFormInputs
    const forms = form?.asset?.value?.map((file: File) => {
      return {
        name: file.name.replace(/\.[^/.]+$/, ''),
        extension: file.type,
        asset: file,
      }
    })
    return forms || []
  }
}

export type TReceiptForm = ReceiptForm & ReceiptFormInputs
